import React from 'react';
import './InputFormsForAnswers.scss';
import { closeInputForms, idQuizesCreate } from '../../../adminSlice';

export default class AddInputFormsForQuizes  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',
            userInputDescription: '',
            userInputCategory: '',
            userInputValue: '',
           
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);

      this.handleUserInputDescription = this.handleUserInputDescription.bind(this);
      this.handleCategory = this.handleCategory.bind(this);
      this.handleValue = this.handleValue.bind(this);
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;
        const item = {
            quiz_name: this.state.userInputContent,
            quiz_description: this.state.userInputDescription,
            sub_id: this.props.adminState.selectedSubCategory,
            quiz_category: this.state.userInputCategory,
            quiz_value: this.state.userInputValue,
            creator_id: this.props.userId,
            
        }
        console.log(item);
        dispatch(idQuizesCreate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}




handleUserInputDescription(e) {
    this.setState(
        {
            userInputDescription: e.target.value
        }
    )
}
 //HANDLE CATEGORY
 handleCategory(event) {
    this.setState(
     {
       userInputCategory: event.target.options[event.target.selectedIndex].value  
     }
    )           
}
//HANDLE VALUE
handleValue(event) {
 this.setState(
  {
    userInputValue: event.target.options[event.target.selectedIndex].value  
  }
 )           
}



// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
      return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openAddInputFormsForQuizes) {
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новый тест:</p>
             <form>
             
                 <label>
                     Введите название теста:</label>
                    
                 <textarea  onChange={this.handleUserInputContent} ></textarea>
                 

                 <label>
                     Введите описание теста:</label>
                 <textarea  onChange={this.handleUserInputDescription} 
                 > </textarea>
                 
                 <label for="category">Категория</label>
                        <select name="category"  onChange={this.handleCategory}>
                        <option value="" selected disabled hidden>Выбрать категорию</option>
                            <option value="3" >Железобетонные конструкции</option>
                            <option value="2">Стальные конструкции</option>
                            <option value="1">Деревянные конструкции</option>
                            <option value="9">Основания и фундаменты</option>
                            <option value="7">Другое</option>
                        </select>
                        
                        <label for="value-quiz">Баллы</label>
                        <select name="value-quiz" onChange={this.handleValue} >
                        <option value="" selected disabled hidden>Выбрать баллы</option>
                            <option value="5" >100</option>
                            <option value="4">80</option>
                            <option value="3">50</option>
                            <option value="2">30</option>
                            <option value="1">10</option>
                            

                        </select>

             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}